import instance from '@apis/instance';
import {
    ProjectResponse,
    ProjectsResponse,
    TestShopResponse,
} from '@models/project';

class ProjectApi {
    static getProjects(): Promise<ProjectsResponse> {
        return instance.get('/v0/projects');
    }

    static getProject(): Promise<ProjectResponse> {
        return instance.get('/v0/project');
    }

    static getTestShops(): Promise<TestShopResponse> {
        return instance.get('/v0/project/test-shops');
    }
}

export default ProjectApi;
